<template>
  <div class="page-journal-index">
    <n-card v-if="project">
      <n-input title="Проект" text :value.sync="project.title" />
    </n-card>
    <component :is="'j-'+journalName" v-if="journal && project"
               :project="project" :journal="journal" :data="journal.data?journal.data:data" :loading="$var('load')" :editable="editable"
               @reload="loadJournal" />

    <page-record-create v-if="newRecord" @close="$router.push(closeRecord)" @submit="recordCreated" />
  </div>
</template>

<script>
import journals from './journals'
import PageRecordCreate from '../records/create/Index'

export default {
  name: 'PageJournalIndex',
  components: { PageRecordCreate, ...journals, },
  data: () => ({
    journal: null,
    project: null,
    data: {
      smr: '',
      gpMan: 'Начальник, Комбатуров С.Т.',
      gpr: 'ТОО "Caspian Business Support"',
      tn: 'ТОО "ABE&K" [140341023240]',
      vj: 'Администратор, Красилов Алексей Дмитриевич',
      date: '01.05.2020',
      q1: '',
      q2: '',
      q3: '',
      q4: '',
      q5: '',
      q6: '',
      q7: '',
      q8: '',
      q9: '',
      q10: '',
      q11: '',

      now: $app.date.format($app.date.now()),
      client: 'ТОО «YERKIN MANAGEMENT GROUP”',
      genExecutor: 'ТОО "DIRECT CONSTRUCTION SERVICE"',
      genProject: 'ТОО "Caspian Business Support"',
      tech: 'ТОО "ABE&K" [140341023240]',
      prorab: 'Администратор, Красилов Алексей Дмитриевич',
    },
  }),
  computed: {
    journalName() {
      return this.$route.params.journal
    },
    projectId() {
      return this.$route.params.projectId
    },
    newRecord() {
      return this.$route.query['new-record'] !== undefined
    },
    closeRecord() {
      return { query: { ...this.$route.query, 'new-record': undefined, }, }
    },
    editable() {
      return $app.auth.can('projects_edit_journals', this.project.id)
    },
  },
  watch: {
    journalName() {
      this.loadJournal()
    },
  },
  created() {
    this.loadProject()
  },
  methods: {
    recordCreated() {
      this.loadProject()
      this.$router.push(this.closeRecord)
    },
    loadProject() {
      this.$var('load', true)
      $api.iq.projects.get(this.projectId).then((response) => {
        this.project = response.data.content
        this.loadJournal()
        $app.router.setPage('projects.index', {
          title: this.project.title,
          to: { name: 'project.index', params: { projectId: this.projectId, }, },
        })
      }).catch(() => {
        this.$var('load', false)
      })
    },
    loadJournal() {
      this.$var('load', true)
      const api = $api.journals.get(this.project.id, this.journalName).query({
        'with[signs][with][author]': null,
      })
      api.then((response) => {
        this.journal = response.data.content
        // $app.router.setPage({ title: this.journal.title, })
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-journal-index {
  --n-modal-width: 1400px;
  &::v-deep {
    .chapter-title {
      font-size: 1.5em;
      text-align: center;
      margin: 30px auto 55px;
      max-width: 800px;
      font-weight: 300;
      line-height: 1.3;
    }
    .chapter-info {
      font-size: .9em;
      ul {
        list-style: decimal;
      }
      li {
        margin: 10px;
      }
    }
    .right-info {
      text-align: right;
    }
    .n-table {
      font-size: .9em;
      .header {
        td, .cell {
          font-weight: 500;
          padding: 5px;
          border: 1px var(--n-table-border);
          text-align: center;
        }
      }
    }

  }
}
</style>
